var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 5.5a.6.6 0 0 1 .6.6v4.8a.6.6 0 0 1-1.2 0V6.1a.6.6 0 0 1 .6-.6zm.419-2.15a.743.743 0 0 0-.111-.061.656.656 0 0 0-.67.103.647.647 0 0 0-.234.51.554.554 0 0 0 0 .126c.008.042.02.083.036.123a.76.76 0 0 0 .14.21c.128.121.3.184.477.176a.565.565 0 0 0 .127 0 .545.545 0 0 0 .235-.097.504.504 0 0 0 .18-.178.527.527 0 0 0 .097-.36.646.646 0 0 0-.189-.46.761.761 0 0 0-.088-.091zM15 7.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0zm-1.154 0a6.346 6.346 0 1 0-12.692 0 6.346 6.346 0 0 0 12.692 0z",
    fill: "#77889A",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover);
export default __webpack_public_path__ + "static/media/info-hover.048457a3b539cee7ad66630a3895a432.svg";
export { ForwardRef as ReactComponent };